<template>
    <!-- 精彩直播 -->
    <div class="live_warp">
        <div class="contanner">
            <div class="banner_top">
                <img :src="topImg" alt="">
            </div>
            <template v-if="list.length">
                <!-- <div class="live_title">
                    <img src="~@/assets/live.png" alt="">
                </div> -->
                <div class="live_list">
                    <div class="list_item" v-for="item in list" :key="item.id" @click="toDetail(item)">
                        <div class="item_img_box">
                            <el-image class="item_img" :src="item.image" >
                                <div slot="placeholder" class="image_slot">
                                    <i class="el-icon-loading"></i>
                                </div>
                            </el-image>
                            <div class="img_time_box" v-if="false">
                                <div>直播倒计时</div>
                                <div> 倒计时：5 天  03 : 01 : 02</div>
                            </div>
                            <div class="item_status">直播预告</div>
                        </div>
                        <div class="item_info">
                            <div class="item_info_title ellipsis">{{item.title}}</div>
                            <div class="item_info_time">直播时间：{{item.createTime}}</div>
                            <div>
                                <img class="item_footer_icon" :src="item.venueLogo" >
                                <span>{{item.venueName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
           
            <!-- 精彩回放 --> 
            <!-- 暂时隐藏 -->
            <div class="live_title playback_title" v-if="false">
                <img src="~@/assets/playback.png" alt="">
                <img src="~@/assets/tab_1.png" alt="">
            </div>
            <div class="live_list" v-if="false">
                <div class="list_item" v-for="i in 6" :key="i" @click="toDetail(item)">
                    <div class="item_img_box">
                        <img src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-11-10/imgMiddleCompress/a4fce45910604709a38f4f98c7286028.jpeg" alt="">
                        <div class="img_time_box img_play_box">
                            <i class="el-icon-video-play" style="font-size:60px"></i>
                        </div>
                        <div class="item_status status_1">精彩回放</div>
                    </div>
                    <div class="item_info">
                        <div class="item_info_title ellipsis">2020年云南省花灯滇剧艺术周开幕式及开幕式演出《回家》</div>
                        <div class="bot">
                            <span style="margin-right:auto;color: #2f7ef7;">播放 31761</span>
                            <svg-icon icon-class="comment" class-name="card-panel-icon" />
                            <span style="margin-right:7px">{{1}}</span>
                            <svg-icon icon-class="thumb" class-name="card-panel-icon" />
                            <span>{{1}}</span>
                        </div>
                        <div class="item_footer">
                            <img class="item_footer_icon" src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-06-01/source/9b388f9766b64b4cbf7dabe8c27852ac.png" >
                            <span style="margin-right:auto">云南省文化馆</span>
                            <span>11-16</span>
                        </div>
                    </div>
                </div>
            </div>
            <Pagination
            :total="total"
            :page.sync="currentPage"
            :limit.sync="pageSize"
            @pagination="handleCurrentChange"
        />
        </div>
    </div>
</template>

<script>
import Pagination from '@c/Pagination'
import { post } from '@u/request'
export default {
    name: 'live',
    components: {
        Pagination
    },
    data() {
        return {
            total: 0,
            currentPage: 1,
            pageSize: 10,
            topImg: '',
            menuType: null,
            menuid: '',
            list: []
        }
    },
    methods: {
        toDetail(item) {
            this.$router.push(`/live/detail/${item.id}`)
        },
        handleCurrentChange() {

        },
        async loadImage() {
            // 获取顶部图片
            const {data} = await post(`resource/showmenu/get/${this.$route.query.id}`);
            this.topImg = data.bgimage;
            this.menuType = data.type;
            this.loadList()
        },
        async loadList() {
            // 获取内容列表
            const loading = this.$loading('.live_warp')
            const params = {
                pid: this.$route.query.id,
                menutype: this.menuType,
                menuid: this.menuid,
                venueIds: this.$store.getters.venueId,
                page: this.currentPage,
                limit: this.pageSize
            }
            const { data,count } = await post('resource/showapi/list',params).catch(()=> loading.close());
            loading.close();
            this.list = data.map(item => {
                if (item.venueLogo && item.venueLogo.indexOf('/images') === 0) {
                    item.venueLogo = VUE_APP_URL + (item.venueLogo.substr(1))
                }
                return item
            });
            this.total = count;
        },
    },
    mounted() {
        this.loadImage()
    }
}
</script>

<style scoped lang="scss">
.live_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    padding: 20px 0;
    .banner_top {
        height: 320px;
        border-radius: 10px;
        overflow: hidden;
        >img {
            width: 100%;
            height: 100%;
        }
    }
    .live_title {
        padding: 45px 0;
    }
    .live_list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        .list_item {
            width: 386px;
            height: 355px;
            background: #fff;
            box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
            border-radius: 5px;
            margin: 0 20px 20px 0;
            cursor: pointer;
            overflow: hidden;
            &:nth-child(3n) {
                margin-right: 0;
            }
        }
        .item_img_box {
            height: 217px;
            position: relative;
            .item_img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                ::v-deep {
                    img {
                        object-fit: cover;
                    }
                }
            }
        }
        .img_time_box {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            line-height: 30px;
            font-size: 20px;
            color: #fff;
            text-align: center;
            background: rgba(0,0,0,.5);
            font-weight: bold;
        }
        .image_slot {
            text-align: center;
            padding-top: 50px;
            font-size: 30px;
        }
        .item_status {
            position: absolute;
            top: 18px;
            left: 18px;
            width: 86px;
            height: 24px;
            line-height: 24px;
            border-radius: 24px 24px 24px 0;
            font-weight: 400;
            text-align: center;
            color: #fff;
            font-size: 14px;
            background: #ff9c00;
            z-index: 100;
        }
        .status_1 {
            background: #2f7ef7;
        }
        .item_info {
            padding: 18px;
            font-size: 14px;
        }
        .item_info_title {
            font-size: 18px;
            color: #000;
            padding-bottom: 18px;
        }
        .item_info_time {
            color: #c72d2d;
            padding-bottom: 17px;
        }
        .item_footer_icon {
            width: 32px;
            height: 32px;
            margin-right: 7px;
        }
        .img_play_box {
            background: rgba(0,0,0,.1);
        }
        .bot {
            display: flex;
            align-items: center;
            color: #777;
            margin-bottom: 15px;
        }
        .item_footer {
            font-size: 14px;
            display: flex;
            align-items: center;
            color: #777;
        }
    }
    .playback_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .card-panel-icon {
        font-size: 16px;
        margin-right: 7px;
    }
}
</style>